import React, { useEffect, useState } from "react";
import { statsAPI } from "../../services/api";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const StatsCounter = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        console.log("Fetching stats...");
        const response = await statsAPI.getDashboard();
        console.log("Stats response:", response);

        if (response.data && response.data.success) {
          setStats(response.data.data);
        } else {
          setError("รูปแบบข้อมูลไม่ถูกต้อง");
        }
      } catch (error) {
        console.error("Failed to fetch stats:", error);
        setError(error.message || "ไม่สามารถโหลดข้อมูลสถิติได้");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const statCards = [
    {
      icon: "fas fa-project-diagram",
      value: stats?.totalProjects || 0,
      label: "โครงการทั้งหมด",
      color: "from-blue-500 to-blue-600",
    },
    {
      icon: "fas fa-brain",
      value: stats?.totalKnowledge || 0,
      label: "องค์ความรู้",
      color: "from-green-500 to-green-600",
    },
    {
      icon: "fas fa-newspaper",
      value: stats?.totalNews || 0,
      label: "ข่าวประชาสัมพันธ์",
      color: "from-cyan-500 to-cyan-600",
    },
    {
      icon: "fas fa-users",
      value: stats?.totalMembers || 0,
      label: "บุคลากร",
      color: "from-yellow-500 to-yellow-600",
    },
    {
      icon: "fas fa-eye",
      value: stats?.totalVisitors || 0,
      label: "ผู้เข้าชม",
      color: "from-red-500 to-red-600",
    },
  ];

  if (loading) {
    return (
      <div className="py-12 bg-gradient-to-b from-white to-gray-50">
        <div className="container-custom">
          <div className="flex justify-center">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-12 bg-gradient-to-b from-white to-gray-50">
        <div className="container-custom text-center">
          <p className="text-red-500">เกิดข้อผิดพลาด: {error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600"
          >
            ลองใหม่อีกครั้ง
          </button>
        </div>
      </div>
    );
  }

  return (
    <div ref={ref} className="py-12 bg-gradient-to-b from-white to-gray-50">
      <div className="container-custom">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
          {statCards.map((stat, index) => (
            <div
              key={index}
              className="p-6 text-center bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div
                className={`inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-gradient-to-r ${stat.color} text-white text-2xl`}
              >
                <i className={stat.icon}></i>
              </div>
              <div className="text-3xl font-bold text-gray-800">
                {inView ? (
                  <CountUp end={stat.value} duration={2.5} separator="," />
                ) : (
                  "0"
                )}
              </div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsCounter;
